import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "FORMS/REVIEW_APPROVE_FORMS/STATE_PAYROLL_FORMS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPayrollStatusList: (state, action) => {
            state.payrollStatusList = action.payload;
        },

        setSelectedPayrollStatus: (state, action) => {
            state.payrollSelectedStatus = action.payload;
        },

        setPayrollStateList: (state, action) => {
            state.payrollStateList = action.payload;
        },
        setSelectedPayrollState: (state, action) => {
            state.selectedPayrollState = action.payload;
        },
        setPayrollFormList: (state, action) => {
            state.payrollFormList = action.payload;
        },
        setSelectedPayrollForm: (state, action) => {
            state.selectedPayrollForm = action.payload;
        },
        setPayrollTaxYearList: (state, action) => {
            state.payrollTaxYearList = action.payload;
        },
        setSelectedPayrollTaxYear: (state, action) => {
            state.selectedPayrollTaxYear = action.payload;
        },
        setPayrollPayerList: (state, action) => {
            state.payrollPayerList = action.payload;
        },
        setSelectedPayrollPayer: (state, action) => {
            state.selectedPayrollPayer = action.payload;
        },
        setStatePayrollFormsGrid: (state, action) => {
            state.statePayrollFormsGrid = action.payload;
        },
        setSelectedStatePayrollFormsGrid: (state, action) => {
            state.selectedStatePayrollForms = action.payload;
        },
        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setPayrollApproveFormsModal: (state, action) => {
            state.payrollApproveFormsModal = action.payload;
        },
        setPayrollRejectFormsModal: (state, action) => {
            state.payrollRejectFormsModal = action.payload;
        },
        setPayrollRejectFormRemark: (state, action) => {
            state.payrollRejectFormRemark = action.payload;
        },
        setReloadGridData: (state, action) => {
            state.reloadGridData = action.payload;
        },
        setFormApprovalSuccess: (state, action) => {
            state.formApprovalSuccess = action.payload;
        },
        setUrlStatusParam: (state, action) => {
            state.urlStatusParam = action.payload;
        },
        setUrlFormIdParam: (state, action) => {
            state.urlFormIdParam = action.payload;
        },
        setUrlPayerIdParam: (state, action) => {
            state.urlPayerIdParam = action.payload;
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        //Filters
        payrollStatusList: [],
        payrollSelectedStatus: { label: "", value: "" },

        payrollStateList: [],
        selectedPayrollState: { label: "", value: "" },

        payrollFormList: [],
        selectedPayrollForm: { label: "", value: "" },

        payrollTaxYearList: [],
        selectedPayrollTaxYear: { label: "", value: "" },

        payrollPayerList: [],
        selectedPayrollPayer: { label: "", value: "" },

        //Grid
        statePayrollFormsGrid: [],
        selectedStatePayrollForms: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            SearchByTIN: "",
            SearchByName: "",
            IsDesc: true,
            Skip: 0,
            total: 10,
        },

        payrollRejectFormRemark: "",

        //Modals
        reloadGridData: false,
        payrollApproveFormsModal: false,
        payrollRejectFormsModal: false,
        formApprovalSuccess: false,
        urlStatusParam: null,
        urlFormIdParam: null,
        urlPayerIdParam: null,
    }
})

export const { setLoadingState, setPayrollStatusList, setSelectedPayrollStatus, setPayrollStateList, setSelectedPayrollState, setPayrollFormList, setSelectedPayrollForm, setPayrollTaxYearList, setSelectedPayrollTaxYear, setPayrollPayerList, setSelectedPayrollPayer, setStatePayrollFormsGrid, setSelectedStatePayrollFormsGrid, setPaginationState, setPayrollApproveFormsModal, setPayrollRejectFormsModal, setPayrollRejectFormRemark, setReloadGridData, setFormApprovalSuccess, setUrlStatusParam, setUrlFormIdParam, setUrlPayerIdParam } = actions;


